module.exports = __webpack_public_path__ + "img/netherworld.aec48dba.png";